var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    role: "img",
    "aria-label": "two men",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 2,
    floodColor: "#1b2a2d",
    floodOpacity: 0.35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 43c-12 0-21 10-21 23v10c0 4 3 7 7 7h28c4 0 7-3 7-7V66c0-13-9-23-21-23z",
    fill: "#3c78b5",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 80V56",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 80V56",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17,
    fill: "#f1c27d",
    stroke: "#263238",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 25c1-13 8-20 19-20 9 0 16 6 16 15 0 2 0 4-1 6-5-8-14-6-21-12-3 6-8 8-13 11z",
    fill: "#2c2c2c",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 27,
    r: 2,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 27,
    r: 2,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 35c4 3 8 3 12 0",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 41c-11 0-20 9-20 22v10c0 4 3 7 7 7h26c4 0 7-3 7-7V63c0-13-9-22-20-22z",
    fill: "#62a36c",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 77V54",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 77V54",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 23,
    r: 16,
    fill: "#e6b36f",
    stroke: "#263238",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 23c1-11 8-18 18-18 9 0 15 6 15 14 0 2 0 4-1 6-5-6-12-5-19-11-3 5-7 7-13 9z",
    fill: "#33251f",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 26,
    r: 2,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 26,
    r: 2,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 34c4 3 8 3 12 0",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenGroup);
export default __webpack_public_path__ + "static/media/men-group.927ce9a149c86807c492e54ff497bfe8.svg";
export { ForwardRef as ReactComponent };